import { TrashBaseIcon } from '@tableau/icons/TrashBaseIcon';
import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';

export type DeleteRoutingFilterButtonProps = Readonly<{
  onClick: () => void;
  disabled?: boolean;
}>;

export function DeleteRoutingFilterButton(props: DeleteRoutingFilterButtonProps) {
  return (
    <ButtonWidget
      testId="delete-routing-filter-button"
      buttonType={ButtonType.Icon}
      onClick={props.onClick}
      title={Messages.bridgeSiteSettingsDeleteRoutingFilter()}
      aria-label={Messages.bridgeSiteSettingsDeleteRoutingFilter()}
      disabled={props.disabled}
    >
      <TrashBaseIcon size={14} aria-hidden={true} alt={''} />
    </ButtonWidget>
  );
}
